import { useEffect, useLayoutEffect, useRef } from 'react';
import { formatPlayerTime } from './playerPrefs';

type Props = {
  seconds: number;
  onRestart: () => void;
  onDismiss: () => void;
};

const AUTO_DISMISS_MS = 6000;

/** Aviso no bloqueante: el video retomó donde el estudiante se quedó. */
export default function ResumeToast({ seconds, onRestart, onDismiss }: Props) {
  // El padre se re-renderiza en cada timeupdate: la referencia evita reiniciar el temporizador.
  const onDismissRef = useRef(onDismiss);
  useLayoutEffect(() => { onDismissRef.current = onDismiss; }, [onDismiss]);

  useEffect(() => {
    const id = window.setTimeout(() => onDismissRef.current(), AUTO_DISMISS_MS);
    return () => window.clearTimeout(id);
  }, [seconds]);

  return (
    <div
      role="status"
      className="motion-fade absolute bottom-20 left-4 z-30 flex items-center gap-3 rounded-lg border border-white/15 bg-black/85 py-2 pl-3 pr-2 text-sm text-white"
    >
      <span>
        Retomando en <span className="font-semibold tabular-nums">{formatPlayerTime(seconds)}</span>
      </span>
      <button
        type="button"
        onClick={onRestart}
        className="min-h-9 rounded-md px-3 text-xs font-semibold text-primary transition-colors hover:bg-white/10 pointer-coarse:min-h-11"
      >
        Empezar de cero
      </button>
    </div>
  );
}
